<template>
    <div class="card-body px-0 pt-0 pb-3">
        <div class="table-responsive">
            <el-table border :data="this.data" class="el-table-css" style="width: 100%" max-height="75vh">
                <el-table-column width="43">
                    <template #default="scope">
                        <el-button class="edit-btn" @click="this.$emit('open-dialog', null, true, scope.row, 'LIST')"
                            style="color: #4db2e5; padding: 0 !important;" :icon="Edit" text />
                    </template>
                </el-table-column>
                <el-table-column prop="descr" label="Şərt" />

                <el-table-column width="43">
                    <template #default="scope">
                        <el-popover style="max-width: 1000px !important;" :width="null" placement="right-start"
                            title="Info" trigger="hover" class="edit-btn">
                            <template #reference>
                                <el-button type="default" style="padding: 0 !important;" :icon="InfoFilled" text />
                            </template>
                            <template #default>
                                <div>
                                    Daxil olunub &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{ scope.row.created }} <br>
                                    Düzəliş
                                    olunub &nbsp;&nbsp;&nbsp; {{ scope.row.updated }}
                                </div>
                            </template>
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column width="43" v-if="priv?.canDelete">
                    <template #default="scope">
                        <el-button type="danger" style="padding: 0 !important;" :icon="Delete" class="edit-btn"
                            @click="DeleteItem(scope.row)" text />
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
import {
    Delete,
    Edit,
    InfoFilled
} from "@element-plus/icons-vue"; 

export default {
    props: {
        data: Array,
        refindex: Number,
        constindex: Number,
        priv: Object
    },
    data() {
        return {
            type: null,
            dialogVis: false,
            Delete,
            Edit,
            page: 1,
            object: null,
            InfoFilled,
            editing: false,
            alert: false,
            sub: {
                constindex: null,
                refindex: 0
            },

        }
    },
    watch: {
        refindex() {
            if (this.id == this.sub.constindex) {
                this.sub.refindex = this.sub.refindex + 1
            }
        }
    },
    methods: {
        OpenDialog(index, edit, object, type) {
            this.sub.constindex = index
            this.id = index
            this.type = type
            this.$emit('open-dialog', index, edit, object, type)
        },
        async DeleteItem() {
             //None
        }
    }
}
</script>
<style scoped>
.diaq-row {
    --el-table-tr-bg-color: #f8caca !important;
}
</style>